import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import * as cnpj from '@fnando/cnpj';
import * as cpf from '@fnando/cpf';

export class Validacoes {
  static validaCpfCnpj(controle: AbstractControl) {
    const cpfCnpj = controle.value;
    console.log('>>>>>>>>> ' + cpfCnpj);
    if (cpfCnpj === '000.000.000-00') {
      return null;
    }
    if (cpf.isValid(cpfCnpj)) {
     return null;
    }
    if (cnpj.isValid(cpfCnpj)) {
      return null;
    }
    return { cpfCnpjInvalido: true };
  }

  static equalsTo(otherField: string) {
    const validator = (formControl: FormControl) => {
      if (otherField == null) {
        throw new Error('É necessário informar um campo.');
      }

      if (!formControl.root || !(formControl.root as FormGroup).controls) {
        return null;
      }

      const field = (formControl.root as FormGroup).get(otherField);

      if (!field) {
        throw new Error('É necessário informar um campo válido.');
      }

      if (field.value !== formControl.value) {
        return { equalsTo : otherField };
      }

      return null;
    };
    return validator;
  }

  static getErrorMsg(fieldName: string, validatorName: string, validatorValue?: any) {
    const config = {
      required: `${fieldName} é obrigatório.`,
      minlength: `${fieldName} precisa ter no mínimo ${validatorValue.requiredLength} caracteres.`,
      maxlength: `${fieldName} precisa ter no máximo ${validatorValue.requiredLength} caracteres.`,
      cepInvalido: 'CEP inválido.',
      emailInvalido: 'Email já cadastrado!',
      equalsTo: 'Campos não são iguais',
      pattern: 'Campo inválido'
    };

    return config[validatorName];
  }
}
